module.exports = __webpack_public_path__ + "img/MDI-calendar-clock.ba20aaaf.svg";